import React from "react";

// ✅ Default structure in required format
export const defaultCoverageData = [
  {
    group: "Employees",
    category: "Permanent",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
  {
    group: "Employees",
    category: "Other Than Permanent",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
  {
    group: "Employees",
    category: "Total Employees",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
  {
    group: "Workers",
    category: "Permanent",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
  {
    group: "Workers",
    category: "Other Than Permanent",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
  {
    group: "Workers",
    category: "Total Workers",
    current: { total: "", covered: "", percentage: "" },
    previous: { total: "", covered: "", percentage: "" },
  },
];

const CoverageComparisonTable = ({ coveragedata = [], setCoverageData }) => {
  // Normalize to array if legacy format accidentally passed
  const normalizedData = Array.isArray(coveragedata)
    ? coveragedata
    : defaultCoverageData;
  console.log(normalizedData, "normal");

  const handleChange = (index, section, field, value) => {
    const updated = [...normalizedData];
    updated[index][section][field] = value;
    setCoverageData(updated);
  };

  const renderRow = (row, index) => {
    return (
      <tr key={`${row.group}-${row.category}`}>
        <td style={leftCellStyle}>{row.category}</td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.current.total}
            onChange={(e) =>
              handleChange(index, "current", "total", e.target.value)
            }
            placeholder="Total (A)"
            style={inputStyle}
          />
        </td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.current.covered}
            onChange={(e) =>
              handleChange(index, "current", "covered", e.target.value)
            }
            placeholder="Covered (B)"
            style={inputStyle}
          />
        </td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.current.percentage}
            onChange={(e) =>
              handleChange(index, "current", "percentage", e.target.value)
            }
            placeholder="% (A/B)"
            style={inputStyle}
          />
        </td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.previous.total}
            onChange={(e) =>
              handleChange(index, "previous", "total", e.target.value)
            }
            placeholder="Total (C)"
            style={inputStyle}
          />
        </td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.previous.covered}
            onChange={(e) =>
              handleChange(index, "previous", "covered", e.target.value)
            }
            placeholder="Covered (D)"
            style={inputStyle}
          />
        </td>
        <td style={cellStyle}>
          <input
            type="text"
            value={row.previous.percentage}
            onChange={(e) =>
              handleChange(index, "previous", "percentage", e.target.value)
            }
            placeholder="% (D/C)"
            style={inputStyle}
          />
        </td>
      </tr>
    );
  };

  return (
    <div style={{ marginTop: 20, overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid black",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Category
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____ <br /> Current Financial Year
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____ <br /> Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>Total (A)</th>
            <th style={headerStyle}>No. of employees/ workers Covered (B)</th>
            <th style={headerStyle}>% (A/B)</th>
            <th style={headerStyle}>Total (C)</th>
            <th style={headerStyle}>No. of employees/ workers Covered (D)</th>
            <th style={headerStyle}>% (D/C)</th>
          </tr>
        </thead>
        <tbody>
          {["Employees", "Workers"].map((group) => (
            <React.Fragment key={group}>
              <tr>
                <td colSpan="7" style={sectionHeaderStyle}>
                  <div style={{ textAlign: "center" }}>{group}</div>
                </td>
              </tr>
              {normalizedData
                .map((row, index) => ({ ...row, index }))
                .filter((r) => r.group === group)
                .map((row) => renderRow(row, row.index))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid black",
  textAlign: "center",
};

const sectionHeaderStyle = {
  padding: "10px",
  backgroundColor: "#D3C9CE",
  fontWeight: "bold",
  border: "1px solid black",
};

const leftCellStyle = {
  padding: "10px",
  border: "1px solid black",
  backgroundColor: "#F0E9EC",
  fontWeight: "bold",
  textAlign: "left",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid black",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
};

export default CoverageComparisonTable;
